import { Swiper, Navigation, Pagination, Autoplay } from 'swiper'
import { breakpointUp } from '../utils/breakpoints'

Swiper.use([Navigation, Pagination, Autoplay]);

let navigationSpace = 62
let navigationFollowerWidth = 62
let initialSlideIndex = Math.floor(Math.random() * $('.jury-navigation-slider .jury-slide-nav').length)

let $curSlide = $('.js-jury-cur-slide')
let follower = $('.active-slide-follower')
follower.css('width', navigationFollowerWidth + 'px')

const swiper = new Swiper('.jury-slider', {

  loop: true,
  initialSlide: initialSlideIndex,
  autoplay: {
    delay: 3000,
    pauseOnMouseEnter: true,
    disableOnInteraction: true
  },
  speed: 800,
  navigation: {
    nextEl: '.jury-nav-next',
    prevEl: '.jury-nav-prev',
  },
  on: {
    slideChange: function () {
      updateSwiperNavigation(this.realIndex)
      $curSlide.text(this.realIndex + 1)
    }
  }

});

const swiperNavigation = new Swiper('.jury-navigation-slider', {

  slidesPerView: 'auto',
  centeredSlides: true,
  loop: true,
  //loopedSlides: 5,
  spaceBetween: navigationSpace,
  initialSlide: initialSlideIndex,
  on: {
    afterInit: function () {
      $('.jury-navigation-slider .swiper-slide-active').addClass('swiper-navigation-active')
      updateActiveSliderFollower()
    },
    slideChange: function () {
      setTimeout(function (){
        updateActiveSliderFollower()
      }, 350)
    }
  },

})

function updateSwiperNavigation(nextIndex) {

  if(swiperNavigation) {
    swiperNavigation.slideTo(nextIndex, 150, function (){
      updateActiveSliderFollower()
    })

    setTimeout(function (){
      $('.swiper-navigation-active').removeClass('swiper-navigation-active')
      $('.jury-slide-nav[data-slide-index="'+nextIndex+'"]').addClass('swiper-navigation-active')
      updateActiveSliderFollower()
    }, 350)

  }
}

function updateActiveSliderFollower()
{
  let activeElement = document.querySelector('.swiper-navigation-active')
  if(activeElement) {
    let active = activeElement.getBoundingClientRect()
    let activePosition = active.left
    let followerPosition = activePosition + ((active.width - navigationFollowerWidth) / 2)
    follower.css('left', followerPosition + 'px')
  }

}

$('body').on('click', '.jury-slide-nav', function (e){
  //swiper.autoplay.stop()
  $('.swiper-navigation-active').removeClass('swiper-navigation-active')
  $(this).addClass('swiper-navigation-active')

  swiper.slideToLoop(parseInt($(this).attr('data-slide-index')), 350)
  setTimeout(function (){
    updateActiveSliderFollower()
    //swiper.autoplay.start()
  }, 350)

})

$('body').on('mouseenter', '#jury .background-image', function (e){

  if(breakpointUp('lg')) {
    let image = $(this).find('.image')
    let video = $(this).find('video').get(0)

    if(video && video.paused) {
      image.addClass('hidden')
      video.playbackRate = 2;
      video.play()
    }
  }


})

$('body').on('mouseleave', '#jury .background-image', function (e){
  if(breakpointUp('lg')) {
    let image = $(this).find('.image')
    let video = $(this).find('video').get(0)

    if (video) {

      image.removeClass('hidden')
      video.pause()
      video.currentTime = 0
    }
  }
})

$(window).on('load', function (){
  updateActiveSliderFollower()
})
